var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v("Allow Authorization"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-mode" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src: "https://www.vectorlogo.zone/logos/reddit/reddit-tile.svg",
                              alt: "Reddit",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Reddit1111")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Home")]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: { type: "checkbox", id: "" },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Popular")]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: { type: "checkbox", id: "" },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [_c("span", [_vm._v("Data type")])]),
                        _vm._v(" "),
                        _c("dd", [
                          _c("select", { staticClass: "go-form-control" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.dataType,
                                    expression: "formData.dataType",
                                  },
                                ],
                                staticClass: "go-form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.formData,
                                      "dataType",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      disabled: "",
                                      selected: "selected",
                                      value: "' '",
                                    },
                                  },
                                  [_vm._v("Select Data Type")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value:
                                        "DROP_BOX_CLOUD_STORAGE_ALL_DOCUMENTS",
                                    },
                                  },
                                  [_vm._v("Document (doc, docx…)")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value:
                                        "DROP_BOX_CLOUD_STORAGE_ALL_EXCELS",
                                    },
                                  },
                                  [_vm._v("Excel (xlsx, csv…)")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value:
                                        "DROP_BOX_CLOUD_STORAGE_ALL_PRESENTATIONS",
                                    },
                                  },
                                  [_vm._v("Presentation (pptx…)")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "DROP_BOX_CLOUD_STORAGE_ALL_PDFS",
                                    },
                                  },
                                  [_vm._v("PDF files")]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-form-group" }, [
                        _c("div", { staticClass: "go-input-group" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-form-group" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-block-between" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v("Select a folder"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Sample Input",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          _c("div", { staticClass: "go-form-feedback-valid" }, [
                            _vm._v(
                              "Your verification code has been successfully verified."
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "separator" }, [
                  _c("div", { staticClass: "line" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("OR")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v("Back")]
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }